document.addEventListener('DOMContentLoaded', () => {
  const textWrapper = document.getElementById('text-wrapper-race');

  if (!textWrapper) return;

  const originalTexts = [...textWrapper.children];

  const clone = originalTexts[0].cloneNode(true);
  textWrapper.appendChild(clone);

  const texts = textWrapper.children;
  const height = originalTexts[0].offsetHeight;
  let index = 0;

  function scrollText() {
    index++;
    textWrapper.style.transform = `translateY(-${index * height}px)`;

    if (index === texts.length - 1) {
      setTimeout(() => {
        textWrapper.style.transition = 'none';
        textWrapper.style.transform = 'translateY(0)';
        index = 0;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            textWrapper.style.transition = 'transform 1s ease-in-out';
            scrollText();
          });
        });
      }, 1500);
    } else {
      setTimeout(scrollText, 1500);
    }
  }

  setTimeout(scrollText, 1500);
});
